import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';

const container = document.getElementById('root')!;
const root = createRoot(container);

// In preview mode, boot the MSW worker before the first render so the app's
// initial API calls are served dummy data. Dynamically imported and env-gated,
// so MSW never runs in a normal build.
const prepare = async () => {
  if (process.env.REACT_APP_PREVIEW === '1') {
    const { worker } = await import('common/mocks/browser');

    await worker.start({ onUnhandledRequest: 'bypass' });
  }
};

prepare().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
